// src/components/ServiceRecovery/ServiceRecovery.js
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { typography } from '../../styles/typography';
import FeedbackAnalytics from './FeedbackAnalytics';
import InstantFeedbackForm from './InstantFeedbackForm';
import ManagerAlertsInbox from './ManagerAlertsInbox';

const views = [
  { id: 'alerts', component: ManagerAlertsInbox },
  { id: 'analytics', component: FeedbackAnalytics },
  { id: 'feedback', component: InstantFeedbackForm },
];

const ServiceRecovery = ({ defaultView = 'alerts' }) => {
  const location = useLocation();
  const [activeView, setActiveView] = useState(defaultView);

  // Update active view based on route
  useEffect(() => {
    if (location.pathname === '/service-feedback') {
      setActiveView('feedback');
    } else if (location.pathname === '/service-recovery') {
      const params = new URLSearchParams(location.search);
      if (params.get('view') === 'analytics') {
        setActiveView('analytics');
      } else {
        setActiveView('alerts');
      }
    }
  }, [location.pathname, location.search]);

  const ActiveComponent = views.find((v) => v.id === activeView)?.component || ManagerAlertsInbox;

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h5 className={typography.h5} style={{ color: '#000000', marginBottom: '0.5rem' }}>
            Service Recovery & Feedback Loop
          </h5>
          <p className={typography.p} style={{ color: '#666666' }}>
            Manage guest feedback, alerts, and recovery actions
          </p>
        </div>

        {/* Active View Content */}
        <div>
          {activeView === 'feedback' ? (
            <ActiveComponent
              orderId={new URLSearchParams(location.search).get('order_id') || null}
              siteId={new URLSearchParams(location.search).get('site_id') || null}
            />
          ) : (
            <ActiveComponent />
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceRecovery;
